<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '125px'">
<!--          <el-form-item label="落地城市主表ID" prop="scopeCityId">-->
<!--          <el-input v-model="dataForm.scopeCityId" placeholder="落地城市主表ID"></el-input>-->
<!--      </el-form-item>-->
          <el-form-item label="公司" prop="companyId">
              <el-select v-model="dataForm.companyId" @change="getPrice" filterable clearable placeholder="请选择公司">
                  <el-option
                          v-for="item in companys"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
              </el-select>
      </el-form-item>
      <el-form-item label="权重" prop="weight">
          <el-input v-model="dataForm.weight" placeholder="权重"></el-input>
      </el-form-item>

      <el-form-item label="城市昨日平均单价" label-width="125px" prop="avgPrice">
          <el-input v-model="dataForm.avgPrice" placeholder="城市平均单价" disabled></el-input>
      </el-form-item>

      <el-form-item label="分配人数" prop="assignPersonCount">
          <el-input v-model="dataForm.assignPersonCount" placeholder="分配人数" disabled></el-input>
      </el-form-item>
<!--          <el-form-item label="状态（开1、关0）" prop="status">-->
<!--          <el-input v-model="dataForm.status" placeholder="状态（开1、关0）"></el-input>-->
<!--      </el-form-item>-->
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
        companys:[],
        dataForm: {
        id: '',
        scopeCityId: '',
        companyId: '',
        weight: '',
        avgPrice: '',
        assignPersonCount: '',
        status: '',
        createBy: '',
        createTime: '',
        updateBy: '',
        updateTime: '',
        deleteTime: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        scopeCityId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        companyId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        weight: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        // avgPrice: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // assignPersonCount: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        createBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        createTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deleteTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
        this.getCompanysOptions();
        console.log(this.$route.params.scopeCityId)
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    getPrice(id){
      this.$http.get(`/sys/scopecitycompany/yesterdayAvg?scopeCityId=${this.$route.params.scopeCityId}&companyId=${id}`).then(({ data: res })=> {
      
        if (res.code !== 0) {
          this.dataForm.avgPrice = ''
          this.dataForm.assignPersonCount = ''
          return this.$message.error(res.msg)
        }
        this.dataForm.avgPrice = res.data.avgPrice
        this.dataForm.assignPersonCount = res.data.assignPersonCount
      })
    
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/scopecitycompany/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
      //初始化公司下拉框中的选项
      async getCompanysOptions() {
          this.$http.get(`/sys/companies/list`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.companys=[];
              if (res.data!=null){
                  res.data.forEach(element => {
                      this.companys.push({label:element.name,value:element.id})
                  })
              }
          }).catch(() => {})
      },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/scopecitycompany/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
